import React, { useContext } from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

import { DataContext } from '../../../Context/DataContext'
import { UIContext } from '../../../Context/UIContext'

import usePreloadImage from '../../../usePreloadImage'

const TeamCard = React.forwardRef(({data}, ref) => {
    const { strings } = useContext(DataContext)
    const { setMemberModalVisible, setSelectedMember, setCurrentPage } = useContext(UIContext)
    const imageLoaded = usePreloadImage(data.image)

    const handleSelectMember = () => {
        setSelectedMember(data)
        setCurrentPage('member')
        setMemberModalVisible(true)
    }
    return (
        <motion.div
            ref={ref}
            className="mga-membercard"
        >
            <figure
                className={`mga-membercard__image${!imageLoaded ? ' mga-img-loading' : ''}`}
                onClick={handleSelectMember}    
            >
                { imageLoaded && <img src={data.image} alt={data.name} /> }
            </figure>
            <div
                className="mga-membercard__info"
            >
                <h3>{ data.name }</h3>
                <span>{ data.position }</span>
            </div>
            <button
                className="mga-membercard__info__more"
                onClick={handleSelectMember}
            >{ strings.more }</button>
        </motion.div>
    )
})
const MotionTeamCard = motion(TeamCard)

export default MotionTeamCard